export default __webpack_public_path__ + "static/Economic Model Update - Arabic-db2add601e3e89f791f9668449c148a5.pdf";